import { Component, OnInit } from '@angular/core';
import { MessagingModel } from './model/messaging.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-messaging-modal',
  templateUrl: './messaging-modal.component.html',
  styleUrls: ['./messaging-modal.component.scss'],
})
export class MessagingModalComponent implements MessagingModel {
  title: string;
  content: string;
  infoMessage: boolean;
  closeBtnName: string;
  closeFunction: any;
  acceptBtnName = 'Aceptar';
  acceptFunction: any;

  constructor(public bsModalRef: BsModalRef) { }

  onDismiss(): void {
    this.bsModalRef.hide();
    if (this.closeFunction) {
      this.closeFunction();
    }
  }

  onSubmit(): void {
    this.bsModalRef.hide();
    if (this.acceptFunction) {
      this.acceptFunction();
    }
  }

}
